import { API_URL } from '../../../../constants';

const paths = {
  getMyQuotaLimitsByCategories: (brandCode: string): string =>
    `${API_URL}/my-quota-limits-by-categories?brandCode=${brandCode}`,
  getMyQuotaLimitsBySkus: (brandCode: string): string => `${API_URL}/my-quota-limits-per-sku?brandCode=${brandCode}`,
  getMyDiscountRules: (brandCode: string): string => `${API_URL}/my-discount-rules?brandCode=${brandCode}`,
};
export default paths;
